function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}><path d="M15.5 8.333C15.5 5.165 14.29 3.5 12 3.5S8.5 5.165 8.5 8.333c0 2.977 1.747 5.5 3.5 5.5s3.5-2.523 3.5-5.5zm1 0c0 3.468-2.1 6.5-4.5 6.5s-4.5-3.032-4.5-6.5C7.5 4.67 9.077 2.5 12 2.5s4.5 2.169 4.5 5.833zM4 21.5a.5.5 0 0 1-.5-.5c0-5.453 2.805-7.167 8.5-7.167s8.5 1.714 8.5 7.167a.5.5 0 0 1-.5.5zm15.491-1c-.159-4.368-2.464-5.667-7.491-5.667-5.027 0-7.332 1.299-7.491 5.667z" /></svg>;
});